import React, { useState } from "react";

import arrow from "imgs/arrow-right.png";

const WIDTH = 33;

// Transparent click-capture layer overlaying the outermost WIDTH px of the
// day-dots grid at one end of the timeline. It always intercepts pointer
// events (so the dots underneath are unclickable) and reveals a
// semi-transparent arrow in its middle on hover. Clicking scrolls the
// timeline a month in that direction.
export default function EdgeArrow({ inverted, height, onClickCb }) {
  const [hover, setHover] = useState(false);
  if (!height) return null;
  return (
    <div
      style={{
        position: "absolute",
        [inverted ? "right" : "left"]: 0,
        bottom: 0,
        width: WIDTH,
        height: height,
        zIndex: 50,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        userSelect: "none",
        background: hover ? "rgba(0, 0, 0, 0.45)" : "transparent",
        borderRadius: 11,
        transition: "background 120ms ease-out",
      }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={(e) => {
        if (onClickCb) onClickCb(e);
      }}
    >
      <img
        alt={inverted ? "scroll right" : "scroll left"}
        src={arrow}
        style={{
          width: 14,
          filter: "invert(1)",
          opacity: hover ? 1 : 0,
          transition: "opacity 120ms ease-out",
          transform: inverted ? "none" : "rotate(180deg)",
          pointerEvents: "none",
        }}
      />
    </div>
  );
}
